import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, PlusOutline, rem, Text, Tooltip } from '@bonusly/design-system';

import { useBookmark } from '../../context';
import { LabelPill } from './label-pill';
import { Label } from './lib/entities';

interface LabelsDisplayProps {
	labelsToShow?: Array<Label>;
	enableAddLabelButton?: boolean;
	showNewLabelForm?: VoidFunction;
}
export const LabelsDisplay: FC<LabelsDisplayProps> = ({ labelsToShow, enableAddLabelButton = false, showNewLabelForm }) => {
	const { labelsIds, setLabelsIds, suggestions } = useBookmark();
	const { t } = useTranslation('bookmarks');

	const isSelected = (label: Label) => {
		return labelsIds?.includes(label.id);
	};

	const handleSelection = (label: Label) => {
		if (label.readOnly || !labelsIds) {
			return;
		}

		if (!isSelected(label)) {
			setLabelsIds([...labelsIds, label.id]);
		} else {
			setLabelsIds(labelsIds.filter((labelId) => labelId !== label.id));
		}
	};

	return (
		<Flex columnGap={1} rowGap={rem(11)} flexWrap="wrap">
			{labelsToShow?.map((label) => (
				<LabelPill key={label.id} readOnly={label.readOnly} isSelected={isSelected(label)} handleSelection={() => handleSelection(label)} h={rem(34)}>
					<Text fontSize="sm" fontWeight="medium">
						{label.name}
					</Text>
				</LabelPill>
			))}
			{enableAddLabelButton &&
				suggestions?.map((suggestion) => (
					<LabelPill key={suggestion} isSelected h={rem(34)}>
						<Text fontSize="sm" fontWeight="medium">
							{suggestion}
						</Text>
					</LabelPill>
				))}
			{enableAddLabelButton && (
				<Tooltip label={t('bookmark_modal.new_label')} placement="top">
					<Flex alignItems="center">
						<LabelPill key="adding-label" boxSize={rem(32)} borderColor="transparent" bg="secondary.bgAlpha" handleSelection={showNewLabelForm}>
							<PlusOutline size="sm" />
						</LabelPill>
					</Flex>
				</Tooltip>
			)}
		</Flex>
	);
};
